import { useState, useEffect, useCallback } from 'react'

const FAVORITES_STORAGE_KEY = 'dsp-favorite-projects'

export function useFavorites() {
  const [favorites, setFavorites] = useState<Set<string>>(() => {
    try {
      const stored = localStorage.getItem(FAVORITES_STORAGE_KEY)
      if (stored) {
        return new Set(JSON.parse(stored))
      }
    } catch {
      // Ignore localStorage errors
    }
    return new Set()
  })

  useEffect(() => {
    try {
      localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify([...favorites]))
    } catch {
      // Ignore localStorage errors
    }
  }, [favorites])

  const toggleFavorite = useCallback((projectId: string) => {
    setFavorites((prev) => {
      const next = new Set(prev)
      if (next.has(projectId)) {
        next.delete(projectId)
      } else {
        next.add(projectId)
      }
      return next
    })
  }, [])

  const isFavorite = useCallback(
    (projectId: string) => favorites.has(projectId),
    [favorites]
  )

  return {
    favorites,
    toggleFavorite,
    isFavorite,
  }
}
